export default {
    login: {
        wrong_password: "Սխալ գաղտնաբառ",
        enter_email: "Մուտքագրեք ձեր էլ. փոստը",
    },

    about: {
        version: "Տարբերակ",
        about_system: "Այս համակարգի համար խորհուրդ է տրվում օգտագործել դիտարկիչ",
        display_resolution: "Էկրանի թույլատրելիություն",
        package_details: "Փաթեթի մանրամասներ",
        remaining_valid_days: "Մնացած վավեր օրեր՝",
        remaining_device_count: "Մնացած սարքերի քանակը՝",
        no_used: "Օգտագործված՝",
        total_no_limit: "Ընդհանուր սահմանաչափ՝",
    },

    company: {
        company_profile: "Ընկերության տվյալներ",
        name: "Անուն՝",
        code: "Կոդ՝",
        phone: "Հեռախոս՝",
        email: "Էլ. փոստ՝",
        first_name: "Անուն՝",
        last_name: "Ազգանուն՝",
        mobile_number: "Բջջային համար՝",
        city: "Քաղաք՝",
        country: "Երկիր՝",
        address: "Հասցե՝",
        mobile: "Բջջային՝",
        state: "Մարզ/Նահանգ՝",
    },

    retail_client: {
        add_retail_client: "Ավելացնել մանրածախ հաճախորդ",
        edit_retail_client: "Խմբագրել մանրածախ հաճախորդին",
        view_retail_client: "Դիտել մանրածախ հաճախորդին",
        retail_client_name: "Մանրածախ հաճախորդի անուն",
        retail_client_code: "Մանրածախ հաճախորդի կոդ",
        retail_admin_email: "Մանրածախ ադմինիստրատորի էլ. փոստ",
        retail_client_first_name: "Մանրածախ ադմինիստրատորի անուն",
        retail_client_last_name: "Մանրածախ ադմինիստրատորի ազգանուն",
        number_of_devices: "Սարքերի քանակ",
        subscription_start_date: "Բաժանորդագրության մեկնարկի ամսաթիվ",
        subscription_expire_date: "Բաժանորդագրության ավարտի ամսաթիվ",
        select_one_retail: "Ընտրեք մանրածախ հաճախորդ",
    },

    template: {
        view_template: "Դիտել ձևանմուշը",
        add_template: "Ավելացնել ձևանմուշ",
        edit_template: "Խմբագրել ձևանմուշը",
        template_editor: "Ձևանմուշի խմբագիր",
        name: "Ձևանմուշի անուն",
        resolution: "Թույլատրելիություն",
        type: "Ձևանմուշի տեսակ",
        screen_direction: "Էկրանի ուղղություն",
        preview: "Ձևանմուշի նախադիտում",
        screen_model: "Էկրանի մոդել",
        is_bind_device: "Կապե՞լ Gateway-ը",
    },

    editor: {
        product_element: "Ապրանքի տարր",
        price_pule: "Գնի կանոն",
        product_price: "Ապրանքի գին",
        product_label: "Ապրանքի պիտակ",
        quantity: "Քանակ",
        category1: "Կատեգորիա 1",
        category2: "Կատեգորիա 2",
        currency: "Արժույթ",
        origin: "Ծագում",
        manufacturer: "Արտադրող",
        discount_price: "Զեղչված գին",
        barcode: "Շտրիխ կոդ",
        company_logo: "Ընկերության լոգո",
        basic_tags: "Հիմնական պիտակներ",
        image_library: "Պատկերների գրադարան",
        change_rule: "Փոփոխության կանոն",
        free_text: "Ազատ տեքստ",
        add_label: "Ավելացնել պիտակ",
        add_shape: "Ավելացնել պատկեր",
        delete_element: "Ջնջել տարրը",
        rounded_corners: "Կլորացված անկյուններ՝",
        content_example: "Բովանդակության օրինակ",
        bgcolor: "Ֆոնի գույն՝",
        show_border: "Ցուցադրել եզրագիծը՝",
        show_scale: "Ցուցադրել սանդղակը՝",
        show_value: "Ցուցադրել արժեքը՝",
        font_color: "Տառատեսակի գույն՝",
        font_size: "Տառաչափ՝",
        font_style: "Տառատեսակի ոճ",
        font_weight: "Տառատեսակի հաստություն՝",
        font: "Տառատեսակ՝",
        spacing: "Միջակայք՝",
        rotation_angle: "Պտտման անկյուն՝",
        width: "Լայնություն՝",
        height: "Բարձրություն՝",
        opacity: "Թափանցիկություն՝",
        line_color: "Գծի գույն՝",
        foreground_color: "Առաջնային գույն՝",
        level: "Մակարդակ",
        color: "Գույն",
        shape: "Պատկեր",
        line_height: "Տողի բարձրություն",
        content: "Բովանդակություն",
        qrcode: "QR կոդ",
        image: "Պատկեր",
        textBox: "Տեքստային դաշտ",
    },

    openAPI: {
        open_api_client: "Open API հաճախորդ",
        add_open_api: "Ավելացնել Open API հաճախորդ",
        secret_key: "Գաղտնի բանալի",
    },

    picture_library: {
        picture_library: "Պատկերների գրադարան",
        add_picture: "Ավելացնել պատկեր",
        edit_picture: "Խմբագրել պատկերը",
        name: "Պատկերի անուն",
        id: "Պատկերի ID",
        preview: "Պատկերի նախադիտում",
        type: "Պատկերի տեսակ",
        size: "Պատկերի չափ",
        progressing: "Պատկերի մշակում",
        general_user: "Ընդհանուր օգտագործում",
        company_logo: "Ընկերության լոգո",
        original_image: "Բնօրինակ պատկեր",
        dithering_image: "Դիթերինգ պատկեր",
    },

    dashboard: {
        welcome_back: "Բարի վերադարձ։",
        login_for_next: "Ձեր բաժանորդագրությունն ավարտվել է, կարող եք կրկին մուտք գործել",
        days_only: " օր",
        subscription_expires: "Ձեր բաժանորդագրությունը կավարտվի՝ ",
        title: "NuTag վահանակ",
        from_date: "Սկսման ամսաթիվ",
        period: "Ժամանակահատված",
        registered_gateway: "Գրանցված Gateway-ներ",
        registered_ESL: "Գրանցված ESL-ներ",
        gateway_online_status: "Gateway-ի առցանց կարգավիճակ",
        last_refreshed: "Վերջին թարմացում",
        refresh_success_rate: "Թարմացման հաջողության տոկոս",
        total_refreshes: "Ընդհանուր թարմացումներ",
        total_number: "Նշված ժամանակահատվածում ESL-ի թարմացումների ընդհանուր քանակը",
        refreshes: "ԹԱՐՄԱՑՈՒՄՆԵՐ",
        devices_distribution: "Սարքերի բաշխում",
        esl_total_stores: "ESL-ով խանութների թիվը / խանութների ընդհանուր թիվը",
        esl_stores: "ESL-ով հագեցած խանութներ",
        total_stores: "Բոլոր խանութները",
        refresh_events: "Թարմացման իրադարձություններ",
        time_in_hours: "Ժամերով",
        refresh_time: "Թարմացման քանակ",
        success_rate: "Հաջողության տոկոս",
        day: "Օր",
        store: "ԽԱՆՈՒԹ",
        all_stores: "ԲՈԼՈՐ ԽԱՆՈՒԹՆԵՐԸ",
        apply_filters: "ԿԻՐԱՌԵԼ ԶՏԻՉՆԵՐԸ",
        period_from_date: "ԺԱՄԱՆԱԿԱՀԱՏՎԱԾԻ ՍԿԻԶԲ",
        stores_installed: "Տեղադրված խանութներ",
        period_to_date: "ԺԱՄԱՆԱԿԱՀԱՏՎԱԾԻ ԱՎԱՐՏ",
        select_store: "Խնդրում ենք ընտրել խանութ",
    },

    authorization: {
        title: "Լիազորման մակարդակ",
        add: "Ավելացնել լիազորման մակարդակ",
        edit: "Խմբագրել լիազորման մակարդակը",
        view: "Դիտել լիազորման մակարդակը",
        name: "Լիազորման մակարդակի անուն",
        list: "Լիազորման մակարդակների ցանկ",
    },

    product: {
        title: "Ապրանքի տվյալներ",
        add_product_label: "Ավելացնել ապրանքի պիտակ",
        sku: "Ապրանքի SKU",
        category_level1: "Կատեգորիա 1",
        category_level2: "Կատեգորիա 2",
        category_level3: "Կատեգորիա 3",
        currency_symbol: "Արժույթի նշան",
        brand_name: "Ապրանքանիշ",
        origin_of_product: "Ապրանքի ծագում",
        product: "Ապրանք",
        add_product: "Ավելացնել ապրանք",
        view_product: "Դիտել ապրանքը",
        edit_product: "Խմբագրել ապրանքը",
        product_picture: "Ապրանքի նկար",
        product_price: "Ապրանքի գին",
        discount_price: "Զեղչված գին",
        serial_number: "Հ/Հ",
        number_one: "1",
        coca_cola: "Կոկա Կոլա",
        drink: "Ըմպելիք",
        cold_drink: "Զովացուցիչ ըմպելիք",
        number_two: "2",
        model: "Մոդել՝",
        inc_screen_iD: "Էկրանի ID՝",
        position_no: "Դիրքի համար՝",
        resolution: "Թույլատրելիություն՝",
        add_success: "Հաջողությամբ ավելացվեց",
        rgb_settins: "RGB լուսավորման կարգավորումներ",
        please_select_light: "Խնդրում ենք ընտրել լույսի գույնը",
        select_product: "Խնդրում ենք ընտրել ապրանքը",
        total_work_time: "LED լույսերի ընդհանուր աշխատանքի ժամանակը (րոպե)",
        duration_time: "Մուտքագրեք տևողությունը",
        color_rgba: "RGB լույսի գույնը",
    },

    outlet: {
        title: "Վաճառքի կետ",
        add_outlet: "Ավելացնել վաճառքի կետ",
        edit_outlet: "Խմբագրել վաճառքի կետը",
        view_outlet: "Դիտել վաճառքի կետը",
        name: "Վաճառքի կետի անուն",
        code: "Վաճառքի կետի կոդ",
        selected_outlet: "վաճառքի կետ ընտրված է",
    },

    user: {
        name: "Օգտատեր",
        person_list: "Անձանց ցանկ",
        create_person: "Ստեղծել անձ",
        edit_person: "Խմբագրել անձին",
        view_person: "Դիտել անձին",
        person_name: "Անձի անուն",
        person_Id: "Անձի ID",
        user_profile: "Օգտատիրոջ պրոֆիլ",
        person_avatar: "Օգտատիրոջ նկար",
    },

    gateway: {
        gateway: "Gateway",
        viewDeviceDetails: "Դիտել սարքի մանրամասները",
        addDeviceToOutlet: "Ավելացնել սարքը վաճառքի կետին",
        bindDeviceToOutlet: "Կապել սարքը վաճառքի կետին",
        gatewaySerialNumber: "Gateway-ի սերիական համար",
        gatewayName: "Gateway-ի անուն",
        gatewayIPAddress: "Gateway-ի IP հասցե",
        gatewayFirmware: "Gateway-ի որոնված",
        gatewayRunningStatus: "Gateway-ի աշխատանքային կարգավիճակ",
        gatewayUpdateTime: "Gateway-ի թարմացման ժամանակ",
        outlet: "Վաճառքի կետ",
        outletTimeZone: "Վաճառքի կետի ժամային գոտի",
        versionNumber: "Տարբերակի համար",
        gatewayType: "Gateway-ի տեսակ",
        gatewayModel: "Gateway-ի մոդել",
        outletCode: "Վաճառքի կետի կոդ",
        logTime: "Մատյանի ժամանակ",
        logType: "Մատյանի տեսակ",
        logCode: "Մատյանի կոդ",
        enable: "Միացված",
        deviceName: "Սարքի անուն",
        deviceModel: "Սարքի մոդել",
        serialNumber: "Սերիական համար",
        deviceType: "Սարքի տեսակ",
        outletId: "Վաճառքի կետի ID",
        clientName: "Հաճախորդի անուն",
        deviceLog: "Սարքի մատյան",
        view_gateway_details: "Դիտել Gateway-ի մանրամասները",
        select_version: "Խնդրում ենք ընտրել տարբերակը։",
        enter_change: "Խնդրում ենք մուտքագրել 2-ի աստիճան, թույլատրելի միջակայքը՝ 2~65536",
        ground_value: "Խմբի արժեքները 2-ի աստիճաններ են, առավելագույնը՝ 65536",
    },

    screen: {
        edit_screen: "Խմբագրել էկրանը",
        bind_to_screen: "Կապել տվյալները էկրանին",
        screenId: "Էկրանի ID",
        screen_resolution: "Էկրանի թույլատրելիություն",
        positionNo: "Դիրքի համար",
        screenName: "Էկրանի անուն",
        powerStatus: "Սնուցման կարգավիճակ",
        gateway: "Gateway",
        outlet: "Վաճառքի կետ",
        bindToProduct: "Կապել ապրանքին",
        templatePreview: "Ձևանմուշի նախադիտում",

        screenStatus: "Էկրանի կարգավիճակ",
        screenUpdateTime: "Էկրանի թարմացման ժամանակ",
        gatewaySerialNumber: "Gateway-ի սերիական համար",
        gatewayName: "Gateway-ի անուն",
        deviceModel: "Սարքի մոդել",
        deviceType: "Սարքի տեսակ",
        gatewayRunningStatus: "Gateway-ի աշխատանքային կարգավիճակ",
        unbindDevice: "Անջատել սարքը",

        bindData: "Կապել տվյալները",
        normal: "Նորմալ",
        lowPower: "Ցածր լիցք",
        total: "Ընդամենը",
        unbound_templates: "Չկապված ձևանմուշներ։",
        batchUpdateScreen: "Խմբային խմբագրել էկրանները",
        same_screen: "Խնդրում ենք ընտրել նույն թույլատրելիությամբ էկրան",
        is_bindDevice: "Խնդրում ենք ընտրել՝ կապել սարքը, թե ոչ",
        same_advgroup: "Գնապիտակի և Gateway-ի հեռարձակման խումբը չեն համընկնում",
        upgrade_device: "Սարքերի թարմացման ցանկ",
        enter_valid_number: "Խնդրում ենք մուտքագրել վավեր թիվ",
        please_enter: "Խնդրում ենք մուտքագրել LED լույսերի ընդհանուր աշխատանքի ժամանակը (րոպե)",
        select_online_screen: "Խնդրում ենք ընտրել առցանց էկրան",
    },

    events: {
        price_Change_Events: "Գնի փոփոխության իրադարձություններ",
        add_priceChangeEvent: "Ավելացնել գնի փոփոխության իրադարձություն",
        edit_priceChangeEvent: "Խմբագրել գնի փոփոխության իրադարձությունը",
        view_priceChangeEvent: "Դիտել գնի փոփոխության իրադարձությունը",
        priceChangeName: "Գնի փոփոխության անվանում",
        priceChangeRule: "Գնի փոփոխության կանոն",
        templateName: "Ձևանմուշի անուն",
        scheduleTime: "Ժամանակացույց",
        approvalStatus: "Հաստատման կարգավիճակ",
        areaFilter: "Տարածքի զտիչ",
        outlet: "Վաճառքի կետ",
        productFilter: "Ապրանքի զտիչ",
        productElement: "Ապրանքի տարր",
        brand: "Ապրանքանիշ",
        promotionType: "Ակցիայի տեսակ",
        templateSelection: "Ձևանմուշի ընտրություն",
        selectTemplate: "Ընտրեք ձևանմուշը այս գնի փոփոխության համար",
        schedule: "Ժամանակացույց",
        scheduleMode: "Ժամանակացույցի ռեժիմ",
        timeZone: "Ժամային գոտի",
        startPromotion: "Սկսել ակցիան",
        endPromotion: "Ավարտել ակցիան",
        doesNotEnd: "Չի ավարտվում",
        setRepeatCondition: "Սահմանել կրկնության պայմանը",
        immediateSync: "Անմիջական համաժամացում",
        startTime: "Սկսման ժամանակ",
        endTime: "Ավարտի ժամանակ",
        validYear: "Վավեր տարի",
        validMonth: "Վավեր ամիս",
        validDate: "Վավեր ամսաթիվ",
        startDate: "Սկսման ամսաթիվ",
        endDate: "Ավարտի ամսաթիվ",
        days: "Օրեր",
        dates: "Ամսաթվեր",
        allDay: "Ամբողջ օրը",
    },

    approval: {
        approvalList: "Հաստատումների ցանկ",
        priceChangeDetails: "Գնի փոփոխության մանրամասներ",
        viewApprovalRequest: "Դիտել գնի փոփոխության հաստատման հարցումը",
        approvalEvent: "Հաստատման իրադարձություն",
        maker: "Ստեղծող",
        createTime: "Ստեղծման ժամանակ",
        priceChangeName: "Գնի փոփոխության անվանում",
        productFilter: "Ապրանքի զտիչ",
        priceChangeRule: "Գնի փոփոխության կանոն",
        priceChangeRuleName: "Գնի փոփոխության կանոնի անուն",
        templateSelection: "Ձևանմուշի ընտրություն",
        templateName: "Ձևանմուշի անուն",
        schedule: "Ժամանակացույց",
        timeZone: "Ժամային գոտի",
        startTime: "Սկսման ժամանակ",
        endTime: "Ավարտի ժամանակ",
        setRepeatCondition: "Սահմանել կրկնության պայմանը",
        includeExcludeDays: "Ներառել/բացառել շաբաթվա օրերը",
        approve: "Հաստատել",
        reject: "Մերժել",
        rejectUpper: "ՄԵՐԺԵԼ",
        approveUpper: "ՀԱՍՏԱՏԵԼ",
        approvalLog: "Հաստատման մատյան",
        approvalLogEvent: "Հաստատման իրադարձություն",
        approvalLogPerson: "Հաստատող անձ",
        approvalLogApprovalTime: "Հաստատման ժամանակ",
        approvalLogStatus: "Հաստատման կարգավիճակ",
    },

    synchronized: {
        systemRecords: "Համակարգի գրառումներ",

        screenID: "Էկրանի ID",
        outlet: "Վաճառքի կետ",
        product: "Ապրանք",
        deviceSN: "Սարքի SN",
        status: "Կարգավիճակ",
        picture: "Նկար",

        mobile: "Բջջային",
        address: "Հասցե",
        country: "Երկիր",
        stateProvince: "Մարզ/Նահանգ",
        city: "Քաղաք",
        noRecordFound: "Գրառում չի գտնվել։",
        clear: "Մաքրել",
        confirm: "Հաստատել",
        resendPriceEvent: "Կրկին ուղարկել գնի փոփոխության իրադարձությունը",
    },

    price: {
        promotiontype: "Խնդրում ենք ընտրել ակցիայի տեսակը",
        number: "Խնդրում ենք մուտքագրել թիվ",
        maximum_discount: "Առավելագույն զեղչը 100% է",
        select_timezone: "Խնդրում ենք ընտրել ժամային գոտի",
        select_starttime: "Խնդրում ենք ընտրել մեկնարկի ժամանակը",
        select_time: "Խնդրում ենք ընտրել ժամանակը",
        approved: "Հաստատված",
        rejected: "Մերժված",
        deleted: "Ջնջված",
        last_template: "Վերջին օգտագործված ձևանմուշը",
        select_times: "ԸՆՏՐԵԼ ԺԱՄԱՆԱԿԸ",
    },

    enum: {
        does_not_repeat: "Չի կրկնվում",
        daily: "Ամեն օր",
        weekly: "Ամեն շաբաթ",
        monthly: "Ամեն ամիս",
        annually: "Ամեն տարի",
    },

    login_log: {
        title: "Մուտքի մատյան",
        login_msg: "Մուտքի հաղորդագրություն",
        access_time: "Մուտքի ժամանակ",
        address: "Մուտքի հասցե",
        ipaddr: "Մուտքի IP",
        account: "Մուտքի հաշիվ",
        user_name: "Մուտք գործած օգտատեր",
        ipaddr_tip: "Խնդրում ենք մուտքագրել IP",
        user_name: "Օգտատիրոջ անուն",
        user_name_tip: "Խնդրում ենք մուտքագրել օգտատիրոջ անունը",
    },

    operation_log: {
        title: "Գործողությունների մատյան",

        server_person_add: "Ավելացնել օգտատեր",
        server_person_edit: "Խմբագրել օգտատիրոջը",
        server_person_delete: "Ջնջել օգտատիրոջը",
        server_send_email: "Ուղարկել էլ. նամակ",

        server_device_add: "Ավելացնել Gateway",
        server_device_delete: "Ջնջել Gateway-ը",
        server_device_advgroup: "Գնապիտակի հեռարձակման խումբ",

        server_screen_edit: "Խմբագրել գնապիտակը",
        server_screen_led_control: "Լուսավորման կառավարում",
        server_template_post: "Կապել տվյալները",

        server_price_change_event_add: "Ավելացնել գնի փոփոխության իրադարձություն",
        server_price_change_event_edit: "Խմբագրել գնի փոփոխության իրադարձությունը",
        server_price_change_event_delete: "Ջնջել գնի փոփոխության իրադարձությունը",

        server_approval_status: "Հաստատման կարգավիճակ",

        server_screen_resend: "Կրկին ուղարկել գնի փոփոխության իրադարձությունը",

        preview_title: "Գործողությունների մատյանի նախադիտում",
        method: "Գործողության մեթոդ",
        account: "Գործողության հաշիվ",
        ipAddr: "Գործողության IP",
        address: "Գործողության հասցե",
        operationTime: "Գործողության ժամանակ",
        status: "Գործողության կարգավիճակ",
        accountName: "Գործողության հաշիվ",
        accountNameTip: "Խնդրում ենք մուտքագրել հաշիվը",
        ipAddrName: "Գործողության IP",
        ipAddrNameTip: "Խնդրում ենք մուտքագրել IP",
        addressName: "Խնդրում ենք մուտքագրել հասցեն",
        user_name: "Օգտատիրոջ անուն",
        operation_method: "Գործողության մեթոդ",
        operation_time: "Գործողության ժամանակ",
        operation_ipaddr: "Գործողության IP",
        operation_execute_time: "Կատարման ժամանակ",
        operation_message: "Գործողության հաղորդագրություն",
        operation_status: "Գործողության կարգավիճակ",
        browser: "Դիտարկիչ",
        system: "Համակարգ",
        server_client_add: "Ավելացնել մանրածախ հաճախորդ",
        server_client_edit: "Խմբագրել մանրածախ հաճախորդին",
        server_client_delete: "Ջնջել մանրածախ հաճախորդին",
        server_template_add: "Ավելացնել ձևանմուշ",
        server_template_edit: "Խմբագրել ձևանմուշը",
        server_template_delete: "Ջնջել ձևանմուշը",
        server_third_party_app_add: "Ավելացնել API հաճախորդ",
        server_picture_library_add: "Ավելացնել նկար",
        server_picture_library_edit: "Խմբագրել նկարը",
        server_picture_library_delete: "Ջնջել նկարը",
        server_mobile_version_add: "Ավելացնել հավելված",
        server_mobile_version_edit: "Խմբագրել հավելվածը",
        server_mobile_version_delete: "Ջնջել հավելվածը",
        server_role_add: "Ավելացնել թույլտվությունների խումբ",
        server_role_edit: "Խմբագրել թույլտվությունների խումբը",
        server_role_delete: "Ջնջել թույլտվությունների խումբը",
        server_approval_add: "Ավելացնել հաստատման գործընթաց",
        server_approval_edit: "Խմբագրել հաստատման գործընթացը",
        server_approval_delete: "Ջնջել հաստատման գործընթացը",
        server_attribute_add: "Ավելացնել ապրանքի տվյալներ",
        server_attribute_delete: "Ջնջել ապրանքի տվյալները",
        server_outlet_add: "Ավելացնել վաճառքի կետ",
        server_outlet_edit: "Խմբագրել վաճառքի կետը",
        server_outlet_delete: "Ջնջել վաճառքի կետը",
        server_product_add: "Ավելացնել ապրանք",
        server_product_edit: "Խմբագրել ապրանքը",
        server_product_delete: "Ջնջել ապրանքը",
        server_product_upload: "Վերբեռնել ֆայլ",
        server_product_led_control: "Լուսավորման կառավարում",
    },
};
